import { render, staticRenderFns } from "./MedicalCert.vue?vue&type=template&id=2565d440"
import script from "./MedicalCert.vue?vue&type=script&lang=js"
export * from "./MedicalCert.vue?vue&type=script&lang=js"
import style0 from "./MedicalCert.vue?vue&type=style&index=0&id=2565d440&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports